<template>
  <div class="outline">
    <div class="menu">
      <span @click.capture="action('top')">上方添加</span>
      <span @click.capture="action('bottom')">下方添加</span>
      <span @click.capture="action('delete')">删除</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'outline',
  methods: {
    action (tips) {
      this.$emit('action', tips)
    }
  }
}
</script>
<style lang="less">
@line:0;
.outline {
  display: none;
  position: absolute;
  top: @line;
  right: @line;
  left: @line;
  bottom: @line;
  z-index: 1001;
  border: 2px dashed red;
  &:hover .menu{
    display: block;
  }
  .menu {
    position: absolute;
    bottom: 0;
    right: 0;
    display: none;
    line-height: 20px;
    span {
      background-color: #bbbbbb;
      color: #ffffff;
      font-size: 10px;
      padding: 2px 4px;
      cursor: pointer;
      &:hover {
        background-color: #999999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/components/outline.vue